import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Roadmap from './components/Roadmap';
import Staking from './components/Staking';
import WalletActions from './components/WalletActions';
import Faq from './components/Faq';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import { WalletModalProvider } from './components/WalletModalContext';
import ConnectWalletModal from './components/ConnectWalletModal';
import './App.css';

function App() {
  return (
    <WalletModalProvider>
      <div className="app">
        <Navbar />
        <Hero />
        <WalletActions />
        <Features />
        <Roadmap />
        <Staking />
        
        <Faq />
        <Footer />
        <ScrollToTop />
        <ConnectWalletModal />
      </div>
    </WalletModalProvider>
  );
}

export default App;